<template>
  <div>
    <a ref="lienDownload"></a>
    <div class="level" v-if="!clientId">
      <div class="level-left">
        <div v-if="$route.name === 'tableau-de-bord'" class="level-item">
          <p class="has-text-grid-4 has-text-weight-bold">
            {{$t('tableauDeBord.listeRecom.title')}}
          </p>
        </div>
        <div v-if="$route.name === 'liste-recommendation'" class="level-item">
          <b-field>
            <b-select
              :placeholder="$t('general.actionGroupe.placeholder')"
              v-model="action"
              :disabled="!listRecomSelect.length"
              expanded
              style="width: 200px">
            </b-select>
          </b-field>
        </div>
        <div v-if="$route.name === 'liste-recommendation'" class="level-item">
          <b-button
            type="is-primary"
            :disabled="!(action && listRecomSelect.length)">
            <span class="has-text-weight-bold">
              {{$t('general.actionGroupe.actionApplication')}}
            </span>
          </b-button>
        </div>
      </div>
      <LiensActions
        :afficherRecomArchi.sync="afficherRecomArchi"
        :afficherRecomCommande.sync="afficherRecomCommande"
        @filtreChange="actionFiltreChange"
        class="level-right" />
    </div>
    <div class="level" v-if="clientId">
      <div class="level-left">
        <div class="level-item">
          <b-select
            :placeholder="$t('tableauDeBord.listeRecom.actionGroupe.titre')"
            v-model="actionPortail"
            :disabled="!listRecomSelect.length">
            <option
              v-for="option in optionsAffichagePortail"
              :value="option.value"
              :key="option.label">
              {{ option.label }}
            </option>
          </b-select>
        </div>
        <div class="level-item">
          <b-button
            type="is-primary"
            class="is-size-7"
            :disabled="actionPortail === null || !listRecomSelect.length"
            @click="setAffichagePortail(listRecomSelect.map(recom => recom.id), actionPortail)">
            {{ $t('tableauDeBord.listeRecom.actionGroupe.btnAppliquer') }}
          </b-button>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <BtnCreerRecommendation />
        </div>
      </div>
    </div>

    <b-table
      :data="dataRecom"
      :loading="loading"
      :checkable="checkable || !!clientId"
      :checked-rows.sync="listRecomSelect"
      ref="tableRecom"
      :sticky-header="estPageListeRecommendation"
      :class="{ 'liste-recom-sticky-header': estPageListeRecommendation }"
      :style="styleHauteurMaxTableau"
      backend-sorting
      @sort="onSort">
      <template >
        <b-table-column v-for="column in columns"
          :key="column.id"
          v-bind="column">
          <template
            v-if="column.searchable"
            #searchable="props">
              <b-select
                v-model="myFilter[props.column.field]"
                v-if="column.field === 'societeId'"
                :placeholder="$t('general.placeolderSearch')"
                expanded
                @input="loadAsyncData"
              >
                <option
                  v-for="(societe, i) in societes"
                  :key="i"
                  :value="societe.id">
                  {{ societe.libelle }}
                </option>
              </b-select>
            <b-input v-else
              v-model="myFilter[props.column.field]"
              :placeholder="$t('general.placeolderSearch')"
              icon="magnify"
              @keyup.native="actionkeyUp"
              @keydown.native="actionkeyDown"/>
          </template>
          <template v-slot="props">
            <div v-if="column.field === 'pointDeVente' && !column.action">
              <div
                class="is-flex media-align-center my-1"
                v-for="i in props.row.intervenants"
                :key="i.id">
                  <figure class="media-left">
                    <img height="30" width="30" :src="getImg(i.urlLogo)">
                  </figure>
                  <div class="media-content">
                    {{ i.nomCommercial }}
                  </div>
              </div>
            </div>
            <div v-else-if="column.action">
              <b-button
                class="has-background-transparent has-text-primary no_border"
                size="is-medium"
                :icon-right="column.icon"
                :disabled="getDisabledButton(column, props.row)"
                @click="actionColumnAction(column.field, props)"/>
            </div>
            <div v-else-if="column.field === 'societeId' && !column.action">
              {{ getLibellSociete(props.row.societeId) }}
            </div>
            <div v-else-if="column.field === 'userId' && !column.action">
              {{ getUserLibelle(props.row.userId) }}
            </div>
            <div v-else-if="column.field === 'devisNum'">
              <span>{{ props.row.devisNum }}</span>
              <span v-if="props.row.issueRenouvellement">&nbsp;({{ $t('general.renouvellement') }})</span>
            </div>
            <div v-else-if="column.field === 'portail'">
              <div class="field">
                <b-switch
                  type="is-success"
                  v-model="props.row.afficherSurPortail"
                  @input="afficher => setAffichagePortail([props.row.id], afficher)">
                </b-switch>
              </div>
            </div>
            <div v-else>
              {{ props.row[column.field] }}
            </div>
          </template>
        </b-table-column>
      </template>
    </b-table>
    <div ref="paginationRecom" class="level pt-3 pb-20" v-if="listeRecommandations.length && $route.name === 'liste-recommendation'">
      <div class="level-left"></div>
      <div class="level-right">
        <div class="level-item is-size-7 has-text-default">
          {{$t('tableauDeBord.listeRecom.libelPerPage')}}
        </div>
        <div class="level-item">
          <b-select placeholder="10" class="is-primary" v-model="perPage" @input="onPageChange(page)">
            <option v-for="value in listePerPageValue" :key="value" :value="value">
              {{value}}
            </option>
          </b-select>
        </div>
        <div class="level-item">
          <b-pagination
            :total="totalRecommandations"
            :current.sync="page"
            order="is-centered"
            :per-page="perPage"
            @change="onPageChange">
          </b-pagination>
        </div>
      </div>
    </div>
    <b-modal
      v-model="isModalDevisAchatOpen"
      :width="1440"
      trap-focus
      aria-role="dialog"
      aria-modal>
        <modal-liste-devis-achat
          v-if="recommandationSelectionnee"
          :societe-id="recommandationSelectionnee.societeId || societeActiveId"
          :reference-externe="recommandationSelectionnee.id"
          @close="isModalDevisAchatOpen = false"/>
    </b-modal>
    <b-modal
      v-model="isModalCopiePdvOpen"
      @cancel="resetStoreRecom"
      :width="840"
      aria-role="dialog"
      trap-focus
      aria-modal>
      <modal-copie-point-de-vente
        v-if="isModalCopiePdvOpen"
        @termine="allerAuPanier"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { formatDate, formatNombre, getImg } from '@/services/general/general';
import * as types from '@/store/modules/user-mutation-type';
import gestionErreur from '@/services/general/gestionErreur';
import { gestionDev } from '@/services/general/general';
import { sansSuite, setAfficherSurPortail  } from '@/api/devis/index';
import { PARAMETRES_KEYS } from '@/store/modules/parametrage-mutation-type';
import { exportPdf } from '@/api/recommandation';
import ModalListeDevisAchat from '@/views/recommandations/ModalListeDevisAchat.vue';
import BtnCreerRecommendation from '@/components/general/BtnCreerRecom.vue';
import LiensActions from '@/components/tableauDeBord/LiensActions.vue';
import ModalCopiePointDeVente from '@/components/recommandation/ModalCopiePointDeVente';
import rechercheRecommandations, { construireQueryRecommandations } from '@/services/recommandation/rechercheRecommandations';
import getSocieteDefautUtilisateur from '@/services/societe/getSocieteDefautUtilisateur';
import {
  MODIF_RECOM,
  COPIE_RECOM,
  ARCHIVER_RECOM,
  DESARCHIVER_RECOM,
  VOIR_DEVIS_ACHAT,
} from '@/configuration/configRecom';
import {
  POINT_VENTE,
  ENSEIGNE,
  GROUPE,
} from '@/configuration/clientConf';
import {
  ETAT_COMMANDE_PARTIELLEMENT,
  ETAT_ENREGISTRE,
  ETAT_COMMANDE,
} from '@/configuration/devisConf';

const User = createNamespacedHelpers('user');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametrage');
const Recommandations = createNamespacedHelpers('recommandations');

const HAUTEUR_MIN_TABLEAU = 300;

export default {
  components: {
    LiensActions,
    ModalListeDevisAchat,
    BtnCreerRecommendation,
    ModalCopiePointDeVente,
  },
  props: {
    checkable: {
      type: Boolean,
      default: false
    },
    clientId: {
      type: String,
      default: null
    },
    clientType: {
      type: String,
      default: null
    },
    societeId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      listeRecommandations: [],
      totalRecommandations: 0,
      perPage: 10,
      sortField: 'dateCreation',
      sortOrder: 'desc',
      defaultSortOrder: 'desc',
      page: 1,
      listePerPageValue: [5, 10, 20],
      myFilter: {
        pointDeVente: '',
        dateCreation: '',
        dateModif: '',
        userId: '',
        montant: '',
        devisNum: '',
        societeId: '',
        pointDeVenteIds: [],
        enseigneIds: [],
        groupeIds: [],
      },
      afficherRecomArchi: false,
      afficherRecomCommande: false,
      hauteurMaxTableau: null,
      listRecomSelect: [],
      typingTimer: null,
      doneTypingInterval: 2000,
      action: null,
      actionPortail: null,
      isModalDevisAchatOpen: false,
      recommandationSelectionnee: null,
      isModalCopiePdvOpen: false,
    };
  },
  computed: {
    ...User.mapGetters({
      user: 'user'
    }),
    ...Societe.mapGetters({
      societes: 'societes',
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    users() {
      return this.parametre(PARAMETRES_KEYS.utilisateur);
    },
    estPageListeRecommendation() {
      return this.$route.name === 'liste-recommendation';
    },
    styleHauteurMaxTableau() {
      if (!this.estPageListeRecommendation || !this.hauteurMaxTableau) return null;
      return { '--hauteur-max-tableau': `${this.hauteurMaxTableau}px` };
    },
    optionsAffichagePortail() {
      return [
        { label: this.$t('tableauDeBord.listeRecom.actionGroupe.afficherPortail'), value: true },
        { label: this.$t('tableauDeBord.listeRecom.actionGroupe.masquerPortail'), value: false },
      ];
    },
    dataRecom() {
      if (!this.listeRecommandations.length) return [];
      return this.listeRecommandations.map(recom => ({
        dateCreation: this.formatDate(recom.creationTime),
        dateModif: this.formatDate(recom.lastModificationTime),
        userId: recom.commercialId,
        montant: this.formatNombre(recom.montantTtc),
        devisNum: recom.code,
        valider: [ETAT_ENREGISTRE, ETAT_COMMANDE, ETAT_COMMANDE_PARTIELLEMENT].includes(recom.etat),
        ...recom,
      }));
    },
    columns() {
      return [
        {
          field: 'pointDeVente',
          label: this.$t('tableauDeBord.listeRecom.column.client'),
          searchable: true,
          sortable: false,
          'header-class': 'is-size-7 has-text-grid-1 pa-20',
          'cell-class': 'is-size-7 has-text-default px-20'
        },
        {
          field: 'dateCreation',
          label: this.$t('tableauDeBord.listeRecom.column.date'),
          searchable: true,
          sortable: true,
          'header-class': 'is-size-7 has-text-grid-1 pa-20',
          'cell-class': 'is-size-7 has-text-default px-20 has-text-middle'
        },
        {
          field: 'dateModif',
          label: this.$t('tableauDeBord.listeRecom.column.dateModif'),
          searchable: true,
          sortable: true,
          'header-class': 'is-size-7 has-text-grid-1 pa-20',
          'cell-class': 'is-size-7 has-text-default px-20 has-text-middle'
        },
        {
          field: 'userId',
          label: this.$t('tableauDeBord.listeRecom.column.commercial'),
          searchable: true,
          sortable: false,
          'header-class': 'is-size-7 has-text-grid-1 pa-20',
          'cell-class': 'is-size-7 has-text-default px-20 has-text-middle'
        },
        {
          field: 'montant',
          label: this.$t('tableauDeBord.listeRecom.column.montant'),
          searchable: true,
          sortable: true,
          'header-class': 'is-size-7 has-text-grid-1 pa-20',
          'cell-class': 'is-size-7 has-text-default px-20 has-text-middle has-text-right'
        },
        {
          field: 'devisNum',
          label: this.$t('tableauDeBord.listeRecom.column.devis'),
          searchable: true,
          sortable: true,
          'header-class': 'is-size-7 has-text-grid-1 pa-20',
          'cell-class': 'is-size-7 has-text-default px-20 has-text-middle'
        },
        {
          field: 'societeId',
          label: this.$t('tableauDeBord.listeRecom.column.societe'),
          searchable: true,
          sortable: false,
          'header-class': 'is-size-7 has-text-grid-1 pa-20',
          'cell-class': 'is-size-7 has-text-default px-20 has-text-middle'
        },
        {
          field: 'portail',
          label: this.$t('tableauDeBord.listeRecom.column.portail'),
          searchable: false,
          sortable: false,
          'header-class': 'is-size-7 has-text-grid-1 pa-20 has-text-centered',
          'cell-class': 'is-size-7 has-text-default px-20 has-text-middle',
          centered: true,
        },
        {
          field: 'telecharger',
          label: this.$t('tableauDeBord.listeRecom.column.telecharger'),
          searchable: false,
          'header-class': 'is-size-7 has-text-grid-1 pa-20 has-text-centered',
          'cell-class': 'is-size-7 has-text-default px-20 has-text-middle',
          icon: 'file-pdf',
          action: true,
          centered: true,
          disabled: this.afficherRecomArchi,
        },
        {
          field: MODIF_RECOM,
          label: this.$t('tableauDeBord.listeRecom.column.modifier'),
          searchable: false,
          'header-class': 'is-size-7 has-text-grid-1 pa-20 has-text-centered',
          'cell-class': 'is-size-7 has-text-default px-20 has-text-middle',
          icon: 'reload',
          action: true,
          centered: true,
          disabled: this.afficherRecomArchi,
        },
        {
          field: COPIE_RECOM,
          label: this.$t('tableauDeBord.listeRecom.column.copier'),
          searchable: false,
          'header-class': 'is-size-7 has-text-grid-1 pa-20 has-text-centered',
          'cell-class': 'is-size-7 has-text-default px-20 has-text-middle',
          icon: 'file-multiple',
          action: true,
          centered: true,
          disabled: false,
        },
        {
          field: 'ouvrir',
          label: this.$t('tableauDeBord.listeRecom.column.ouvrir'),
          searchable: false,
          'header-class': 'is-size-7 has-text-grid-1 pa-20 has-text-centered',
          'cell-class': 'is-size-7 has-text-default px-20 has-text-middle',
          icon: 'launch',
          action: true,
          centered: true,
          disabled: this.afficherRecomArchi,
        },
        {
          field: VOIR_DEVIS_ACHAT,
          label: this.$t('tableauDeBord.listeRecom.column.devisAchat'),
          searchable: false,
          'header-class': 'is-size-7 has-text-grid-1 pa-20 has-text-centered',
          'cell-class': 'is-size-7 has-text-default px-20 has-text-middle',
          icon: 'file-document',
          action: true,
          centered: true,
        },
        {
          field: this.afficherRecomArchi ? DESARCHIVER_RECOM : ARCHIVER_RECOM,
          label: this.afficherRecomArchi ? this.$t('tableauDeBord.listeRecom.column.desarchiver') : this.$t('tableauDeBord.listeRecom.column.archiver'),
          searchable: false,
          'header-class': 'is-size-7 has-text-grid-1 pa-20 has-text-centered',
          'cell-class': 'is-size-7 has-text-default px-20 has-text-middle',
          icon: this.afficherRecomArchi ? 'package-up' : 'package-down',
          action: true,
          centered: true
        },
      ]
      .filter(col => {
        if (this.clientId && col.field === 'pointDeVente') return false;
        if (this.clientId && col.field === 'societeId') return false;
        if (!this.clientId && col.field === 'portail') return false;
        return true;
      })
      .map(el => ({
        ...el,
        label: el.sortable ? `↑↓ ${el.label}` : el.label,
      }));
    },
  },
  methods: {
    ...Recommandations.mapActions({
      actionSaveRecomToStore: 'initialierRecommandationDevis',
      actionGetPdf: 'getPdfRecom',
      resetStoreRecom: 'resetStore',
    }),
    ...User.mapMutations({
      setIsClick: types.SET_IS_CLICK,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getDisabledButton(column, row) {
      const isOrderedRow = [ETAT_COMMANDE, ETAT_COMMANDE_PARTIELLEMENT].includes(row.etat);
      return column.disabled
        || (column.field === DESARCHIVER_RECOM)
        || (column.field === MODIF_RECOM && row.valider)
        || (column.field === ARCHIVER_RECOM && isOrderedRow)
        || (column.field === VOIR_DEVIS_ACHAT && !row.valider);
    },
    formatNombre(nombre) {
      if (!nombre) return formatNombre(0);
      return formatNombre(nombre);
    },
    formatDate(date) {
      return formatDate(date);
    },
    getImg(img) {
      return getImg(img);
    },
    async loadAsyncData() {
      this.loading = true;
      try {
        const query = construireQueryRecommandations({
          perPage: this.perPage,
          page: this.page,
          sortOrder: this.sortOrder,
          sortField: this.sortField,
          filtres: this.myFilter,
          afficherRecomArchi: this.afficherRecomArchi,
          afficherRecomCommande: this.afficherRecomCommande,
        });
        const { items, totalCount } = await rechercheRecommandations(query);
        this.listeRecommandations = items;
        this.totalRecommandations = totalCount;
      } catch (error) {
        gestionErreur('Erreur lors de la récupération des recommandations', error);
        throw error;
      } finally {
        this.loading = false;
        this.$nextTick(this.calculerHauteurMaxTableau);
      }
    },
    // Hauteur disponible entre le haut du tableau et le bas de la zone visible, pagination déduite
    calculerHauteurMaxTableau() {
      if (!this.estPageListeRecommendation || !this.$refs.tableRecom) return;
      const tableWrapper = this.$refs.tableRecom.$el.querySelector('.table-wrapper');
      if (!tableWrapper) return;
      const conteneur = this.$el.closest('.is-principal-content');
      const hauteurVisible = conteneur ? conteneur.clientHeight : window.innerHeight;
      const topConteneur = conteneur ? conteneur.getBoundingClientRect().top - conteneur.scrollTop : 0;
      const topTableau = tableWrapper.getBoundingClientRect().top - topConteneur;
      const hauteurPagination = this.$refs.paginationRecom ? this.$refs.paginationRecom.offsetHeight : 0;
      this.hauteurMaxTableau = Math.max(HAUTEUR_MIN_TABLEAU, hauteurVisible - topTableau - hauteurPagination);
    },
    onPageChange(page) {
      this.page = page;
      this.loadAsyncData();
    },
    onSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
      this.loadAsyncData();
    },
    async actionRecom(id) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        await this.actionSaveRecomToStore({ devisId: id });
        this.$router.push({ name: 'panier' });
      } catch (error) {
        gestionErreur(`Erreur lors de l'ajout de la recom ${id} au panier`, error);
        throw error;
      } finally {
        loadingComponent.close();
      }
    },
    async actionCopyRecom(recom) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.actionSaveRecomToStore({ devisId: recom.id, isCopy: true });
        this.isModalCopiePdvOpen = true;
      } finally {
        loadingComponent.close();
      }
    },
    allerAuPanier() {
      this.isModalCopiePdvOpen = false;
      this.$router.push({ name: 'panier' });
    },
    async getPdf(id) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const result = await exportPdf(id);
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(result.data);
        const disposition = result.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
      } catch (error) {
        gestionErreur(`Erreur lors de l'export PDF de la recommandation id: ${this.recom.id}`, error);
      } finally {
        loadingComponent.close();
      }
    },
    openModalDevisAchat(recommandation) {
      this.recommandationSelectionnee = recommandation;
      this.isModalDevisAchatOpen = true;
    },
    actionColumnAction(column, props) {
      switch (column) {
        case 'ouvrir':
          this.$router.push({name: 'detail-recommandation', params: { id: props.row.id }});
          break;
        case 'archiver':
          this.archiverRecom(props.row.id);
          break;
        case 'telecharger':
          this.getPdf(props.row.id);
          break;
        case VOIR_DEVIS_ACHAT:
          this.openModalDevisAchat(props.row);
          break;
        case MODIF_RECOM:
          this.actionRecom(props.row.id);
          break;
        case COPIE_RECOM:
          this.actionCopyRecom(props.row);
          break;
        default:
          gestionDev();
          break;
      }
    },
    actionkeyUp() {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(this.loadAsyncData, this.doneTypingInterval);
    },
    actionkeyDown() {
      clearTimeout(this.typingTimer);
    },
    async archiverRecom(id) {
      const loadingComponent = this.$buefy.loading.open({ container: this.$refs.listRecomClient });
      try {
        await sansSuite(id);
        await this.loadAsyncData();
      } catch (e) {
        gestionErreur(e)
      } finally {
        loadingComponent.close();
      }
    },
    async setAffichagePortail(ids, afficher) {
      if (!ids.length) return;
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        await setAfficherSurPortail(ids, afficher);
        await this.loadAsyncData();
        this.listRecomSelect = [];
        this.actionPortail = null;
      } catch (error) {
        gestionErreur('Erreur lors de la mise à jour de l\'affichage sur le portail', error);
      } finally {
        loadingComponent.close();
      }
    },
    actionFiltreChange() {
      this.page = 1;
      this.loadAsyncData();
    },
    getLibellSociete(societeId) {
      const result =  this.societes.find(s => s.id === societeId);
      return result ? result.libelle : '';
    },
    getUserLibelle(userId) {
      if (!userId) return '';
      const result =  this.users.find(u => u.id === userId);
      return result.email ? result.email : '';
    },
  },
  async mounted() {
    window.addEventListener('resize', this.calculerHauteurMaxTableau);
    await this.loadParametres([PARAMETRES_KEYS.utilisateur]);
    this.myFilter.societeId = this.societeId || getSocieteDefautUtilisateur(this.societes, this.user);
    if (!this.clientId) {
      this.myFilter.userId = this.user.email;
    }
    if (this.clientId && this.clientType) {
      switch(this.clientType) {
        case POINT_VENTE: {
          this.myFilter.pointDeVenteIds = [this.clientId];
          break;
        }
        case ENSEIGNE: {
          this.myFilter.enseigneIds = [this.clientId];
          break;
        }
        case GROUPE: {
          this.myFilter.groupeIds = [this.clientId];
          break;
        }
      }
    }

    this.loadAsyncData();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculerHauteurMaxTableau);
  },
};
</script>
